<template>
<div>
  <v-dialog
    v-if="dialog"
    v-model="dialog"
    width="500"
    persistent
  >
    <v-card>
      <v-card-title>
        <v-row class="d-flex  align-center pb-0" no-gutters>
          <v-col class="h6 grey--text text--darken-1" cols="10">
            {{ $t('batchSchedule.closeModal.title') }}
          </v-col>
          <v-col class="text-right pa-0">
            <v-btn @click="cancel('CONFIRM_CLOSE_BATCH_SCHEDULE_MODAL')" icon>
              <v-icon small>
                mdi-close
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      
      <v-divider />
      
      <v-card-text class="body-1 pt-5 pr-6 pl-6 pb-5">
        <v-card class="pa-5" color="orange lighten-5" elevation="0">
          <span class="orange--text">
            {{ $t('batchSchedule.closeModal.message') }}
          </span>
        </v-card>
      </v-card-text>

      <v-card-actions class="d-flex justify-end pb-5 pr-5">
        <v-btn
          @click="cancel()"
          elevation="0"
          color="grey"
          text
        >
          {{ $t('appointment.closeModal.buttons.cancel') }}
        </v-btn>
        <v-btn
          @click="closeBatchSchedule()"
          color="orange"
          elevation="0"
          class="ml-5"
          dark
        >
          {{ $t('appointment.closeModal.buttons.closeModal') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Modal from '@/components/app/Modal'

export default {
  name: 'ModalConfirmBatchSchedulingClose',

  components: {
    Modal,
  },

  computed: {
    ...mapGetters(['activeModal']),

    dialog() {
      return this.activeModal === 'CONFIRM_CLOSE_BATCH_SCHEDULE_MODAL'
    },
  },

  methods: {
    ...mapActions(['closeModal', 'openModal']),
    ...mapMutations(['closeAllModals']),

    closeCreateModal() {
      this.$emit('closeCreateModal')
    },

    cancel() {
      this.closeModal('CONFIRM_CLOSE_BATCH_SCHEDULE_MODAL')
      this.openModal('BATCH_SCHEDULE_MODAL')
    },

    closeBatchSchedule() {
      this.closeAllModals()
      this.$parent.resetFields()
    },
  },
}
</script>
